'use client';
import { useAppDispatch } from '@/lib/redux/store';
import { isBrowser } from '@/shared/utils/window';
import { Editor } from '@tiptap/react';
import {
  setIsShowingFloatingAttributes,
  setIsShowingFloatingEmoji,
  setIsShowingMediaManager,
} from '../../Jobs/redux/jobEditors.slice';

const useTextEditorShortcuts = (jobId: string = '') => {
  const dispatch = useAppDispatch();

  const closeFloatingItems = () => {
    dispatch(setIsShowingMediaManager({ jobId, isShowing: false }));
    dispatch(setIsShowingFloatingAttributes({ jobId, isShowing: false }));
    dispatch(setIsShowingFloatingEmoji({ jobId, isShowing: false }));
  };

  const handleOnSlashCommand = (editor: Editor) => {
    dispatch(setIsShowingFloatingAttributes({ jobId, isShowing: true }));
    editor.commands.blur();
  };

  const handleAttributesShortcut = (editor: Editor) => {
    dispatch(setIsShowingFloatingAttributes({ jobId, isShowing: true }));
    editor.commands.blur();
  };

  const handleEmojiShortcut = (editor: Editor) => {
    dispatch(setIsShowingFloatingEmoji({ jobId, isShowing: true }));
    editor.commands.blur();
  };

  const handleAddLink = () => {
    const insertLinkButton = document.querySelector(
      '[data-button-id="editor-toolbar-insert-link-button"]'
    ) as HTMLButtonElement;
    if (insertLinkButton) {
      insertLinkButton.click();
    }
  };

  const handleAddMedia = () => {
    const insertMediaButton = document.querySelector(
      '[data-button-id="editor-toolbar-insert-media-button"]'
    ) as HTMLButtonElement;
    if (insertMediaButton) {
      insertMediaButton.click();
    }
  };

  const handleBoldShortcut = () => {
    if (isBrowser()) {
      const boldButton = document.querySelector(
        '[data-button-id="editor-toolbar-bold-button"]'
      ) as HTMLButtonElement;
      if (boldButton) {
        boldButton.click();
      }
    }
  };

  const handleItalicsShortcut = () => {
    const italicsButton = document.querySelector(
      '[data-button-id="editor-toolbar-italics-button"]'
    ) as HTMLButtonElement;
    if (italicsButton) {
      italicsButton.click();
    }
  };

  return {
    handleOnSlashCommand,
    handleAttributesShortcut,
    handleEmojiShortcut,
    handleAddLink,
    handleAddMedia,
    handleBoldShortcut,
    handleItalicsShortcut,
    closeFloatingItems,
  };
};

export default useTextEditorShortcuts;
